<template>
  <div>
    <div :class="shouldPreviewAsPrint ? 'agreement-flow-print' : 'agreement-flow'">
      <FlowPagesWrapper :shouldPreviewAsPrint="shouldPreviewAsPrint" />
    </div>
  </div>
</template>
<script lang="ts">
import { PropType } from 'vue'
import {
  AgreementFlowService,
  AgreementFlowServiceConstructor,
} from './AgreementFlowService'
import FlowPagesWrapper from './FlowPagesWrapper.vue'

export default {
  name: 'AgreementFlow',
  components: { FlowPagesWrapper },
  props: {
    /**
     * AgreementFlowService のコンストラクタ引数を受け取る
     */
    AgreementFlowServiceConstructorArgs: {
      type: Object as PropType<AgreementFlowServiceConstructor>,
      required: true,
    },
    shouldPreviewAsPrint: {
      type: Boolean,
      required: false,
    },
  },
  provide() {
    return {
      AgreementFlowService: this.AgreementFlowService,
    }
  },
  data() {
    return {
      AgreementFlowService: new AgreementFlowService(
        this.AgreementFlowServiceConstructorArgs,
      ),
    }
  },
}
</script>
